// カウンセリング 1 回の長さと、自分の予約どうしの間に取る休み（分）
export const COUNSELING_DURATION_MINUTES = 60;
export const COUNSELING_GAP_MINUTES = 30;

// カウンセリング予約の開始時刻（09:00〜22:30 の 30 分刻み）
const ALL_COUNSELING_TIME_SLOTS = Array.from({ length: 28 }, (_, i) => {
  const minutes = 9 * 60 + i * 30;
  return `${String(Math.floor(minutes / 60)).padStart(2, "0")}:${String(minutes % 60).padStart(2, "0")}`;
});

// 平日夜間のみ（19:30以降） — 一時的に未使用
const _WEEKDAY_EVENING_SLOTS = [
  "19:30",
  "21:00",
  "22:30",
];

// 全枠開放する特定日付（祝日・特別対応日 等） — 一時的に未使用
const _ALL_DAY_OPEN_DATES = new Set<string>([
  "2026-04-29",
  "2026-05-01",
]);

// 曜日に応じた時間枠を返す（一旦すべての曜日で全枠開放）
export function getCounselingSlotsForDate(_date: Date): string[] {
  return ALL_COUNSELING_TIME_SLOTS;
}

// 後方互換: 全枠が必要な場合（管理画面等）
export const COUNSELING_TIME_SLOTS = ALL_COUNSELING_TIME_SLOTS;

// 時間を先に選ぶ版より前の 1.5 時間刻み。体験授業など、別の枠で照らす予約先と共有するカレンダーはこちらを出す
export const COUNSELING_LEGACY_TIME_SLOTS = ALL_COUNSELING_TIME_SLOTS.filter((_, i) => i % 3 === 0);
